import { ValueOfObject } from 'src/types/generics';

const permission = {
  AirtableBasesFilter: 'airtable_bases.filter',
  AirtableBasesView: 'airtable_bases.view',
  AirtableBasesCreate: 'airtable_bases.create',
  AirtableBasesUpdate: 'airtable_bases.update',
  AirtableBasesDelete: 'airtable_bases.delete',
  AirtableBasesAssociate: 'airtable_bases.associate',
  AirtableTablesFilter: 'airtable_tables.filter',
  AirtableTablesView: 'airtable_tables.view',
  AirtableTablesCreate: 'airtable_tables.create',
  AirtableTablesUpdate: 'airtable_tables.update',
  AirtableTablesDelete: 'airtable_tables.delete',
  AirtableModelTemplatesFilter: 'airtable_model_templates.filter',
  AirtableModelTemplatesView: 'airtable_model_templates.view',
  AirtableModelTemplatesCreate: 'airtable_model_templates.create',
  AirtableModelTemplatesUpdate: 'airtable_model_templates.update',
  AirtableModelTemplatesDelete: 'airtable_model_templates.delete',
  SpaceView: 'space.view',
  AdminView: 'admin.view',
  ProfileView: 'profile.view',
  ProfileUpdate: 'profile.update',
  CompaniesFilter: 'companies.filter',
  CompaniesView: 'companies.view',
  CompaniesViewAll: 'companies.view.*',
  CompaniesCreate: 'companies.create',
  CompaniesUpdate: 'companies.update',
  CompaniesUpdateAll: 'companies.update.*',
  CompaniesDelete: 'companies.delete',
  CompaniesDeleteAll: 'companies.delete.*',
  SubscriptionsFilter: 'subscriptions.filter',
  SubscriptionsView: 'subscriptions.view',
  SubscriptionsViewAll: 'subscriptions.view.*',
  SubscriptionsCreate: 'subscriptions.create',
  SubscriptionsUpdate: 'subscriptions.update',
  SubscriptionsUpdateAll: 'subscriptions.update.*',
  SubscriptionsDelete: 'subscriptions.delete',
  SubscriptionsDeleteAll: 'subscriptions.delete.*',
  StripeInvoicesView: 'stripe_invoices.view',
  StripeInvoicesViewAll: 'stripe_invoices.view.*',
  SubscriptionAssignmentsFilter: 'subscription_assignments.filter',
  SubscriptionAssignmentsView: 'subscription_assignments.view',
  SubscriptionAssignmentsViewAll: 'subscription_assignments.view.*',
  SubscriptionAssignmentsCreate: 'subscription_assignments.create',
  SubscriptionAssignmentsUpdate: 'subscription_assignments.update',
  SubscriptionAssignmentsUpdateAll: 'subscription_assignments.update.*',
  SubscriptionAssignmentsDelete: 'subscription_assignments.delete',
  SubscriptionAssignmentsDeleteAll: 'subscription_assignments.delete.*',
  CompanyBrandsFilter: 'company_brands.filter',
  CompanyBrandsView: 'company_brands.view',
  CompanyBrandsViewAll: 'company_brands.view.*',
  CompanyBrandsCreate: 'company_brands.create',
  CompanyBrandsUpdate: 'company_brands.update',
  CompanyBrandsUpdateAll: 'company_brands.update.*',
  CompanyBrandsDelete: 'company_brands.delete',
  CompanyBrandsDeleteAll: 'company_brands.delete.*',
  MediaView: 'media.view',
  MediaViewAll: 'media.view.*',
  MediaShare: 'media.share',
  MediaShareAll: 'media.share.*',
  MediaCreate: 'media.create',
  MediaUpdate: 'media.update',
  MediaUpdateAll: 'media.update.*',
  MediaDelete: 'media.delete',
  MediaDeleteAll: 'media.delete.*',
  RequestsFilter: 'requests.filter',
  RequestsView: 'requests.view',
  RequestsViewAll: 'requests.view.*',
  RequestsCreate: 'requests.create',
  RequestsUpdate: 'requests.update',
  RequestsUpdateAll: 'requests.update.*',
  RequestsChangeStatus: 'requests.change_status',
  RequestsChangeStatusAll: 'requests.change_status.*',
  RequestsChangeEditor: 'requests.change_editor',
  RequestsDelete: 'requests.delete',
  RequestsDeleteAll: 'requests.delete.*',
  RequestsComplete: 'requests.complete',
  RequestsUpdatePriority: 'requests.update_priority',
  RequestRevisionsFilter: 'request_revisions.filter',
  RequestRevisionsView: 'request_revisions.view',
  RequestRevisionsViewAll: 'request_revisions.view.*',
  RequestRevisionsCreate: 'request_revisions.create',
  RequestRevisionsUpdate: 'request_revisions.update',
  RequestRevisionsUpdateAll: 'request_revisions.update.*',
  RequestRevisionsDelete: 'request_revisions.delete',
  RequestRevisionsDeleteAll: 'request_revisions.delete.*',
  RequestRevisionTranscriptsCreate: 'request_revision_transcripts.create',
  RevisionCommentsFilter: 'revision_comments.filter',
  RevisionCommentsView: 'revision_comments.view',
  RevisionCommentsViewAll: 'revision_comments.view.*',
  RevisionCommentsCreate: 'revision_comments.create',
  RevisionCommentsUpdate: 'revision_comments.update',
  RevisionCommentsUpdateAll: 'revision_comments.update.*',
  RevisionCommentsDelete: 'revision_comments.delete',
  RevisionCommentsDeleteAll: 'revision_comments.delete.*',
  UsersFilter: 'users.filter',
  UsersFilterAll: 'users.filter.*',
  UsersFilterAdmin: 'users.filter.admin',
  UsersFilterTeamLead: 'users.filter.team_lead',
  UsersFilterEditor: 'users.filter.editor',
  UsersFilterCustomer: 'users.filter.customer',
  UsersView: 'users.view',
  UsersViewAll: 'users.view.*',
  UsersViewAdmin: 'users.view.admin',
  UsersViewTeamLead: 'users.view.team_lead',
  UsersViewEditor: 'users.view.editor',
  UsersViewCustomer: 'users.view.customer',
  UsersCreate: 'users.create',
  UsersCreateAll: 'users.create.*',
  UsersCreateAdmin: 'users.create.admin',
  UsersCreateTeamLead: 'users.create.team_lead',
  UsersCreateEditor: 'users.create.editor',
  UsersCreateCustomer: 'users.create.customer',
  UsersUpdate: 'users.update',
  UsersUpdateAll: 'users.update.*',
  UsersUpdateAdmin: 'users.update.admin',
  UsersUpdateTeamLead: 'users.update.team_lead',
  UsersUpdateEditor: 'users.update.editor',
  UsersUpdateCustomer: 'users.update.customer',
  UsersDelete: 'users.delete',
  UsersDeleteAll: 'users.delete.*',
  UsersDeleteAdmin: 'users.delete.admin',
  UsersDeleteTeamLead: 'users.delete.team_lead',
  UsersDeleteEditor: 'users.delete.editor',
  UsersDeleteCustomer: 'users.delete.customer',
  UsersTransferToCompany: 'users.transfer_to_company',
  UsersImpersonate: 'users.impersonate',
  UsersImpersonateAll: 'users.impersonate.*',
  UsersImpersonateAdmin: 'users.impersonate.admin',
  UsersImpersonateTeamLead: 'users.impersonate.team_lead',
  UsersImpersonateEditor: 'users.impersonate.editor',
  UsersImpersonateCustomer: 'users.impersonate.customer',
  TeamsFilter: 'teams.filter',
  TeamsView: 'teams.view',
  TeamsViewAll: 'teams.view.*',
  TeamsCreate: 'teams.create',
  TeamsUpdate: 'teams.update',
  TeamsUpdateAll: 'teams.update.*',
  TeamsDelete: 'teams.delete',
  TeamsDeleteAll: 'teams.delete.*',
  TeamMembersFilter: 'team_members.filter',
  TeamMembersView: 'team_members.view',
  TeamMembersViewAll: 'team_members.view.*',
  TeamMembersCreate: 'team_members.create',
  TeamMembersUpdate: 'team_members.update',
  TeamMembersUpdateAll: 'team_members.update.*',
  TeamMembersDelete: 'team_members.delete',
  TeamMembersDeleteAll: 'team_members.delete.*',
  TasksFilter: 'tasks.filter',
  TasksView: 'tasks.view',
  TasksViewAll: 'tasks.view.*',
  TasksCreate: 'tasks.create',
  TasksUpdate: 'tasks.update',
  TasksUpdateAll: 'tasks.update.*',
  TasksDelete: 'tasks.delete',
  TasksDeleteAll: 'tasks.delete.*',
  NotificationsFilter: 'notifications.filter',
  NotificationsView: 'notifications.view',
  NotificationsCreate: 'notifications.create',
  NotificationsUpdate: 'notifications.update',
  NotificationsDelete: 'notifications.delete',
  AuditsFilter: 'audits.filter',
  AuditsView: 'audits.view',
  LanguageLinesFilter: 'language_lines.filter',
  LanguageLinesView: 'language_lines.view',
  LanguageLinesCreate: 'language_lines.create',
  LanguageLinesUpdate: 'language_lines.update',
  LanguageLinesDelete: 'language_lines.delete',
  CompanyPersonnelFilter: 'company_personnel.filter',
  CompanyPersonnelFilterAll: 'company_personnel.filter.*',
  CompanyPersonnelFilterOwner: 'company_personnel.filter.owner',
  CompanyPersonnelFilterAdministrator: 'company_personnel.filter.administrator',
  CompanyPersonnelCreate: 'company_personnel.create',
  CompanyPersonnelCreateAll: 'company_personnel.create.*',
  CompanyPersonnelCreateOwner: 'company_personnel.create.owner',
  CompanyPersonnelCreateAdministrator: 'company_personnel.create.administrator',
  CompanyPersonnelUpdate: 'company_personnel.update',
  CompanyPersonnelUpdateAll: 'company_personnel.update.*',
  CompanyPersonnelUpdateOwner: 'company_personnel.update.owner',
  CompanyPersonnelUpdateAdministrator: 'company_personnel.update.administrator',
  CompanyPersonnelDelete: 'company_personnel.delete',
  CompanyPersonnelDeleteAll: 'company_personnel.delete.*',
  CompanyPersonnelDeleteOwner: 'company_personnel.delete.owner',
  CompanyPersonnelDeleteAdministrator: 'company_personnel.delete.administrator',
  FeatureUsagesReset: 'feature_usages.reset',
} as const;

type Permission = ValueOfObject<typeof permission>;

export { permission };
export type { Permission };
